const strToarray = (str: string, key: string) => str.split(key);

const getValueByKey = (newkey: string[], obj:any) => {
  if (newkey.length === 0) {
    return obj;
  }
  const newObj = obj[newkey[0]];
  newkey.splice(0, 1);
  return getValueByKey(newkey, newObj);
};

const checkPoint = (str: string) => {
  if (str.indexOf('.') === -1) {
    return false;
  }
  return true;
};

const transerStructure = (source :any, replaceField :any, right: boolean) => {
  const replaceFieldArr = [];
  source.forEach((item) => {
    const obj = {};
    Object.keys(replaceField).forEach((key) => {
      if (checkPoint(replaceField[key])) {
        const newkey = strToarray(replaceField[key], '.');
        obj[key] = getValueByKey(newkey, item);
      } else {
        obj[key] = item[replaceField[key]];
      }
    });
    replaceFieldArr.push(obj);
  });
  return replaceFieldArr;
};

export default transerStructure;
